import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

const IndustrialNav = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const navLinks = [
    { href: "/protocol", label: "PROTOCOL" },
    { href: "/infrastructure", label: "INFRASTRUCTURE" },
    { href: "/systems", label: "SYSTEMS" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="max-w-industrial mx-auto px-6 lg:px-10 flex items-center justify-between h-16">
        {/* Brand */}
        <Link to="/" className="font-mono text-[0.85rem] font-bold tracking-wide text-foreground">
          WILLIAM PALMER<span className="hidden xl:inline text-muted-foreground"> //</span> <span className="hidden xl:inline text-muted-foreground font-normal">STRUCTURAL WEB ARCHITECT</span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link, i) => (
            <span key={link.href} className="flex items-center">
              {i > 0 && <span className="text-muted-foreground/40 mx-1 font-mono text-xs">/</span>}
              <Link
                to={link.href}
                className={cn(
                  "font-mono text-xs font-bold uppercase tracking-wider px-3 py-2 transition-colors",
                  isActive(link.href)
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground"
                )}
              >
                {link.label}
              </Link>
            </span>
          ))}
          <Link
            to="/intake"
            className={cn(
              "ml-6 font-mono text-xs font-bold uppercase tracking-wider px-5 py-2.5 transition-colors",
              isActive("/intake")
                ? "bg-primary text-primary-foreground"
                : "text-primary hover:bg-primary hover:text-primary-foreground"
            )}
          >
            [ REQUEST DIAGNOSTIC ]
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden w-10 h-10 flex items-center justify-center"
          aria-label="Toggle menu"
        >
          <div className="space-y-1.5">
            <span className={cn("block w-6 h-0.5 bg-foreground transition-transform", mobileOpen && "rotate-45 translate-y-2")} />
            <span className={cn("block w-6 h-0.5 bg-foreground transition-opacity", mobileOpen && "opacity-0")} />
            <span className={cn("block w-6 h-0.5 bg-foreground transition-transform", mobileOpen && "-rotate-45 -translate-y-2")} />
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden border-t border-border bg-background px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMobileOpen(false)}
              className={cn(
                "block font-mono text-sm font-bold uppercase tracking-wider py-2",
                isActive(link.href) ? "text-primary" : "text-muted-foreground"
              )}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/intake"
            onClick={() => setMobileOpen(false)}
            className="block font-mono text-sm font-bold uppercase tracking-wider py-3 text-primary text-center mt-4"
          >
            [ REQUEST DIAGNOSTIC ]
          </Link>
        </div>
      )}
    </nav>
  );
};

export default IndustrialNav;
